import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {StaticText} from 'app-ui-componentlibrary/dist/componentLibrary/form/StaticText';

export {StaticText};
export default connectWithCore(StaticText);
